import { Container, VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import styled from "styled-components/native";
import {
  getSearchParams,
  getSearchParamsGemstone,
  getSearchParamsJewelry,
} from "../utils/utils";
import { useDispatch } from "react-redux";
import {
  setAuxPayloadData,
  setPayloadData,
  setSectionName,
} from "@redux/slices/searchFilters";
import { ItemCardViewProps } from "./types";
import Routes from "@navigations/Routes";
import VDBMenu from "@components/atoms/Menu";
import { useDeleteSavedSearch, useUpdateTitleSavedSearch } from "@apis/explore";
import { savedSearches } from "@src/types/ExploreResult";
import Popup from "@components/molecules/PopUp";
import { ButtonType } from "@components/atoms/Button/types";
import { messageType } from "@components/molecules/PopUp/types";
import InputPopup from "@components/molecules/InputPopUp";
import {
  SearchFilterTypeEnum,
  SearchFilterTypeEnumLowercase,
} from "@components/atoms/Filters/utils";
import { ProductTypeCommon } from "@utils/constants";
import { VDBIcons } from "@utils/VDBIcons";
import { convertSubOptionsToJewelryPayload } from "@scenes/searchResults/Utils";
import { SpaceType } from "@components/atoms/Spacer/types";
import { View as ShadowView } from "@gluestack-ui/themed/build/components/View";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { useQueryClient } from "@tanstack/react-query";
import { getBoxShadow } from "@utils/product/productValidators";
import { useProductPrefix } from "../../../../hooks/useProductPrefix";
import { navigate } from "@navigations/utils/RootNavigation";

const ItemCardView = ({ item }: ItemCardViewProps) => {
  const { t } = useTranslation();
  const { theme, typography } = useScreenOptionsHooks();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  const [isDeleteDialog, setDeleteDialog] = useState(false);
  const [popUpTitleMessage, setPopUpTitleMessage] = useState(
    t("savedSearch.popUp.title.text")
  );
  const [popUpInputText, setPopUpInputText] = useState("");

  const [popUpNotesMessage, setPopUpNotesMessage] = useState("");

  const [popUpDescriptionMessage, setPopUpDescriptionMessage] = useState("");
  const [showPopUpDialog, setShowPopUpDialog] = useState(false);

  const getDeleteSavedSearchResult = useDeleteSavedSearch();
  const getUpdateTitleSavedSearchResult = useUpdateTitleSavedSearch();
  const queryClient = useQueryClient();
  const productPrefix = useProductPrefix();

  const options = [
    {
      key: "EditTitle",
      label: t("savedSearch.tooltip.editTitle.text"),
      name: "EditTitle",
      action: "edit",
      fontColor: "main-02",
      fontStyle: "",
    },
    {
      key: "DeleteSaved",
      label: t("savedSearch.tooltip.deleteSavedSearch.text"),
      name: "DeleteSaved",
      action: "delete",
      fontColor: "error-01",
      fontStyle: "",
    },
  ];

  const openSavedSearchResult = (itemData: any) => {
    let search_params;
    let payload = {};
    let isPair = false;
    let isLabGrownJewelry = false;
    let sectionName;
    let filterSplitStep = 2;
    switch (itemData.type) {
      case 1:
        search_params = { ...getSearchParams(itemData.search_options) };
        search_params.lab_grown = false;
        isPair = search_params?.pair === SearchFilterTypeEnumLowercase.PAIRS;
        sectionName = isPair
          ? SearchFilterTypeEnum.PAIRS
          : SearchFilterTypeEnum.SINGLE_STONES;
        payload = {
          [SearchFilterTypeEnum.SINGLE_STONES]: isPair ? {} : search_params,
          [SearchFilterTypeEnum.PAIRS]: isPair ? search_params : {},
        };
        break;
      case 2:
        search_params = { ...getSearchParamsGemstone(itemData.search_options) };
        isPair = search_params?.pair === SearchFilterTypeEnumLowercase.PAIRS;
        sectionName = isPair
          ? SearchFilterTypeEnum.PAIRS
          : SearchFilterTypeEnum.SINGLE_STONES;
        payload = {
          [SearchFilterTypeEnum.SINGLE_STONES]: isPair ? {} : search_params,
          [SearchFilterTypeEnum.PAIRS]: isPair ? search_params : {},
        };
        break;
      case 3:
        search_params = {
          ...getSearchParamsJewelry(itemData.search_options, dispatch),
        };
        isLabGrownJewelry =
          search_params?.sub_type ===
          ProductTypeCommon.LABGROWN_JEWELRY_SUB_TYPE;
        sectionName = isLabGrownJewelry
          ? SearchFilterTypeEnum.LAB_GROWN_JEWELRY
          : SearchFilterTypeEnum.JEWELRY;

        if (
          search_params.jewelry_styles &&
          !Array.isArray(search_params.jewelry_styles)
        ) {
          const deconstructJewelryStyles = convertSubOptionsToJewelryPayload(
            search_params,
            "jewelry_styles"
          );
          search_params = {
            ...search_params,
            ...deconstructJewelryStyles,
          };
        }
        if (search_params.metals) {
          const deconstructMetals = convertSubOptionsToJewelryPayload(
            search_params,
            "metals"
          );
          search_params = {
            ...search_params,
            ...deconstructMetals,
          };
        }

        payload = {
          [SearchFilterTypeEnum.JEWELRY]: isLabGrownJewelry
            ? {}
            : { ...search_params },
          [SearchFilterTypeEnum.LAB_GROWN_JEWELRY]: isLabGrownJewelry
            ? { ...search_params }
            : {},
        };
        break;
      case 4:
        search_params = { ...getSearchParams(itemData.search_options) };
        isPair = search_params?.pair === SearchFilterTypeEnumLowercase.PAIRS;
        sectionName = isPair
          ? SearchFilterTypeEnum.PAIRS
          : SearchFilterTypeEnum.SINGLE_STONES;
        payload = {
          [SearchFilterTypeEnum.SINGLE_STONES]: isPair ? {} : search_params,
          [SearchFilterTypeEnum.PAIRS]: isPair ? search_params : {},
        };
        break;
      default:
        search_params = { ...getSearchParams(itemData.search_options) };
        search_params.lab_grown = false;
        isPair = search_params?.pair === SearchFilterTypeEnumLowercase.PAIRS;
        payload = {
          [SearchFilterTypeEnum.SINGLE_STONES]: isPair ? {} : search_params,
          [SearchFilterTypeEnum.PAIRS]: isPair ? search_params : {},
        };
        break;
    }
    dispatch(setSectionName(sectionName));
    dispatch(setAuxPayloadData(payload));
    dispatch(setPayloadData({ data: payload, productType: item?.productType }));
    const tabletParams = {
      productType: item.productType,
      fromResultScreen: false,
      filterSplitStep: filterSplitStep,
      sectionName,
      productPrefix,
    };
    theme.isTablet
      ? navigate(Routes.FilterSplitScreen, tabletParams)
      : theme.isLargeScreen
      ? navigate(Routes.ExploreNavigator, {
          screen: Routes.FilterSplitScreen,
          params: tabletParams,
        })
      : navigate(Routes.SearchResultScreen, {
          productType: item.productType,
          fromNewFilterScreen: false,
          sectionName,
          productPrefix,
        });
  };

  const deleteSearchResultAction = (id: number) => {
    getDeleteSavedSearchResult.mutate(
      { id: id },
      {
        async onSuccess() {
          queryClient.invalidateQueries({ queryKey: ["SAVED_SEARCH"] }).then();
          setLoading(false);
          setShowPopUpDialog(false);
        },
        async onError() {
          setLoading(false);
          setShowPopUpDialog(false);
        },
      }
    );
  };

  const updateSavedSearchTitle = (data: savedSearches, title: any) => {
    data.generated_Title =
      data.title !== data?.generatedTitle ? data?.title : "";

    data.title = title?.title;
    getUpdateTitleSavedSearchResult.mutate(
      { id: data?.id, data: data },
      {
        async onSuccess() {
          setLoading(false);
          setShowPopUpDialog(false);
          queryClient.invalidateQueries({ queryKey: ["SAVED_SEARCH"] }).then();
        },
        async onError() {
          setLoading(false);
          setShowPopUpDialog(false);
        },
      }
    );
  };

  const closePopup = () => {
    setShowPopUpDialog(false);
  };

  const [popUpActionBtns, setPopUpActionBtns] = useState<any>([]);

  const updateTitle = (id: number, data: savedSearches) => {
    setPopUpInputText(data?.title);
    setPopUpDescriptionMessage(t("savedSearch.popUp.description.text"));
    setPopUpNotesMessage(t("savedSearch.popUp.note.text"));
    setPopUpActionBtns([
      {
        type: ButtonType.primary,
        title: t("savedSearch.popUp.save.button.text"),
        isLoadingButton: true,
        onPressAction: (updatedData: any) => {
          setLoading(true);
          updateSavedSearchTitle(data, updatedData);
        },
      },
      {
        type: ButtonType.secondary,
        title: t("savedSearch.popUp.cancel.button.text"),
        isLoadingButton: false,
        onPressAction: closePopup,
      },
    ]);
    setDeleteDialog(false);

    setShowPopUpDialog(true);
  };

  const deleteSearchResult = (id: number) => {
    setPopUpTitleMessage(t("savedSearch.popUp.delete.title.text"));
    setPopUpNotesMessage(t("savedSearch.popUp.delete.description.text"));
    setPopUpDescriptionMessage("");

    setPopUpActionBtns([
      //buttons defined for the popup component
      {
        type: ButtonType.primary,
        title: t("savedSearch.popUp.delete.button.text"),
        isLoadingButton: true,
        onPressAction: () => {
          setLoading(true);
          deleteSearchResultAction(id);
        },
      },
      {
        type: ButtonType.secondary,
        title: t("savedSearch.popUp.deleteCancel.button.text"),
        onPressAction: closePopup,
      },
    ]);
    setDeleteDialog(true);
    setShowPopUpDialog(true);
  };

  const handleActionSelect = (action: any, data: savedSearches) => {
    switch (action) {
      case "edit":
        // Handle edit action
        updateTitle(data.id, data);
        break;
      case "delete":
        // Handle delete action
        deleteSearchResult(data.id);
        break;
      default:
        // Handle default action
        break;
    }
  };

  return (
    <Container maxWidth={theme.isLargeScreen ? "100%" : 608}>
      <CardParent onPress={() => openSavedSearchResult(item)}>
        <SavedSearchCard>
          <CardDetail>
            <CardTitle>
              <VDBText color={theme["core-05"]} type={typography["Body-R"]}>
                {item?.title}
              </VDBText>
            </CardTitle>

            <CenterView>
              <VDBIcon
                name={VDBIcons.ARROW_RIGHT}
                size={24}
                color={theme["core-04"]}
                variant={IconsVariant.VDBCustom}
              />
            </CenterView>
          </CardDetail>
          {item?.generated_Title && (
            <CardSubTitle>
              <VDBText color={theme["core-06"]} type={typography["Minor-R"]}>
                {item.generated_Title}
              </VDBText>
            </CardSubTitle>
          )}
          <DividerView>
            <Divider />
          </DividerView>
          <CardDetail>
            <View>
              <VDBMenu
                options={options}
                onActionSelect={handleActionSelect}
                data={item}
                typography={typography["Minor-M"]}
              />
            </View>

            <CardFont>
              <VDBText type={typography["Minor-M"]} color={theme[item?.theme]}>
                {t(item?.type_text)}
              </VDBText>
            </CardFont>
          </CardDetail>
        </SavedSearchCard>
      </CardParent>

      {showPopUpDialog &&
        (isDeleteDialog ? (
          <Popup
            title={popUpTitleMessage}
            buttons={popUpActionBtns}
            HtmlSource={{
              html: popUpNotesMessage,
            }}
            type={messageType.Error}
            isLoading={isLoading}
            styleKey="Body-R"
          />
        ) : (
          <InputPopup
            title={popUpTitleMessage}
            buttons={popUpActionBtns}
            description={popUpDescriptionMessage}
            notes={popUpNotesMessage}
            showInput={!isDeleteDialog}
            inputText={popUpInputText}
            isLoading={isLoading}
            isForEditSavedSearch={true}
            showPopUpDialog={showPopUpDialog}
            setShowPopUpDialog={setShowPopUpDialog}
            styleKey="Body-R"
            modalType="popUp"
          />
        ))}
    </Container>
  );
};

const SavedSearchCard = styled(ShadowView)`
  margin-bottom: ${SpaceType.Double}px;
  background-color: ${({ theme }) => theme["core-01"]};
  width: 100%;
  border-radius: 8px;
  border-color: ${({ theme }) => theme["core-04"]};
  border-width: 1px;
  box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Gentle)};
`;

const CardTitle = styled.View`
  flex: 1;
`;

const CardSubTitle = styled.View`
  padding: ${SpaceType.Basic}px;
  padding-top: ${SpaceType.Extra}px;
`;

const CardFont = styled.View`
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
`;

const CardParent = styled.TouchableOpacity`
  justify-content: center;
  align-items: center;
`;

const CenterView = styled.View`
  justify-content: center;
  align-items: center;
`;

const CardDetail = styled.View`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 8px;
`;

const DividerView = styled.View`
  flex-direction: row;
  padding-top: 1px;
  padding-bottom: 1px;
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
`;

export default ItemCardView;
